import { Component, effect, inject } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  AppInitializerService,
  AppService,
  BrandService,
  CannyService,
  FeatureFlags,
  GtmService,
  LaunchDarklyService,
  LOGGEDINUSER,
  NavigationHelper,
  User,
  UserAgentService,
} from '@lc/core';
import { Router } from '@angular/router';
import { filter } from 'rxjs/operators';
import { firstValueFrom, merge, Observable } from 'rxjs';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Title } from '@angular/platform-browser';
import { GtmEventsService } from './services/gtm-events/gtm-events.service';

@Component({
  selector: 'lc-agent-app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
  standalone: false,
})
export class AppComponent {
  omniChat$: Observable<Boolean>;
  private readonly GTAG_MAP = new Map([
    ['prod', 'GTM-T6FK2WB'],
    ['uat', 'GTM-MZCLZSD'],
  ]);

  constructor() {
    const userAgentService = inject(UserAgentService);
    const appInitializer = inject(AppInitializerService);
    userAgentService.doBrowserCheck();
    appInitializer.initializeKeys('lc-agent-app', AppService.productSuiteName);

    const router = inject(Router);

    const store = inject(Store);
    const user$: Observable<User> = store
      .select(LOGGEDINUSER)
      .pipe(filter((user: User) => !!user?.profile));

    // Set the canny SSO after user logged in
    const launchDarklyService = inject(LaunchDarklyService);
    const cannyService = inject(CannyService);
    firstValueFrom(user$).then(async () => {
      this.omniChat$ = launchDarklyService.getFeature$(FeatureFlags.OMNI_CHAT, false);
      await firstValueFrom(cannyService.getCannySSO$());
    });

    const gtmService = inject(GtmService);
    const { virtualPageview$, marketingOrderStarted$, marketingOrderStepChange$ } = inject(GtmEventsService);
    merge(virtualPageview$, marketingOrderStarted$, marketingOrderStepChange$)
      .pipe(takeUntilDestroyed())
      .subscribe((event) => gtmService.pushEvent(this.GTAG_MAP, event));

    NavigationHelper.urlChanged$(router).subscribe((url) => appInitializer.refreshNotifications(url));

    const brandService = inject(BrandService);

    const title = inject(Title);
    effect(() => {
      title.setTitle(brandService.applicationName());
    });
  }
}
